<template>
    <div>
        <v-container fluid class="scroll">
            <v-row align="center" justify="space-between">
                <v-col cols="12" md="10">
                    <v-timeline
                        dense
                        clapped
                        class="overflow-x"
                        >
                        <v-timeline-item class="mb-6" hide-dot>
                            <span class="basic--text font-weight-bold">History</span>
                        </v-timeline-item>

                        <v-timeline-item
                            class="mb-4"
                            v-for="(item, index) in records"
                            :key="index"
                            color="green"
                            icon-color="pink">
                            <v-row justify="space-around">
                                <v-col cols="5" md="4">
                                    <span class="font-weight-medium">
                                        {{ item.newData}}
                                    </span>
                                </v-col>

                                <v-col cols="5" md="4" sm="3">
                                   <span class="font-weight-medium">
                                    {{ item.currentData }}
                                   </span>
                                </v-col>

                                <v-col cols="7" md="4" sm="auto">
                                    <span class="font-weight-medium">
                                        {{ new Date(item.updatedTime * 1000).toDateString() }}
                                    </span>
                                </v-col>
                            </v-row>
                        </v-timeline-item>
                    </v-timeline>
                </v-col>

            </v-row>
        </v-container>
        <loading-dialog :show="loading"></loading-dialog>
    </div>
</template>


<script>
import Api from '@/main/api';
import { mapGetters } from "vuex";
import ErrorResolver from '@/shared/ErrorResolver';
import LoadingDialog from '@ui/components/LoadingDialog.vue';

export default {
    name: "HistoryChange",
    components: {
        LoadingDialog
    },

    setup(props, ctx) {

    },

    data: () => ({
        loading: false,
        records: [], //currentData, newData and time changed
    }),

    methods: {
        fetchApplicantHistory() {
            this.loading = true;
            Api.dataCorrection.fetchHistory(this.getUser.userId).then((res) => {
                this.records = res.data;

            }).catch((err) => ErrorResolver.checkErrors(this, err))
            .finally(() => this.loading = false);
        },
    },

    watch: {

    },

    computed: {
        timeline() {
            return this.events.slice().reverse();
        },


        ...mapGetters(['getUser'])
    },

    created() {
        this.fetchApplicantHistory();
    }
}
</script>
